/* global gdAlertify */
import React, { useMemo, useState } from 'react';
import axiosInstance from '../config/axiosConfig';
import MonthInput from "./components/MonthInput";

const buildRange = (periodo) => {
    const [anioStr, mesStr] = String(periodo || '').split('-');
    const anio = Number(anioStr);
    const mes = Number(mesStr);

    if (!anio || !mes) {
        return { fechaMin: '', fechaMax: '' };
    }

    return {
        fechaMin: new Date(anio, mes - 2, 26).toISOString().slice(0, 10),
        fechaMax: new Date(anio, mes - 1, 25).toISOString().slice(0, 10),
    };
};

const PeriodoTurnoRecalculoDia = () => {
    const [periodo, setPeriodo] = useState(new Date().toISOString().slice(0, 7));
    const [fecha, setFecha] = useState('');
    const [turno, setTurno] = useState('3');
    const [extra, setExtra] = useState('');
    const [nota, setNota] = useState('');
    const [resultado, setResultado] = useState(null);

    const { fechaMin, fechaMax } = useMemo(() => buildRange(periodo), [periodo]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!periodo || !fecha) {
            gdAlertify.notiError('Debes indicar período y fecha.');
            return;
        }

        try {
            gdAlertify.showLoader();
            const response = await axiosInstance.post('/turnos/periodos/recalcular-dia', {
                periodo,
                fecha,
                turno: parseInt(turno, 10),
                extra: extra === '' ? 0 : parseFloat(extra),
                nota,
            });

            gdAlertify.hideLoader();

            if (response.data?.error) {
                gdAlertify.notiError(response.data.message || 'No fue posible recalcular el día.');
                return;
            }

            setResultado(response.data?.data || null);
            gdAlertify.alertSuccess(response.data?.message || 'Día recalculado con éxito.');
        } catch (error) {
            gdAlertify.hideLoader();
            gdAlertify.notiError('Error al recalcular el día del período.');
        }
    };

    return (
        <div className="container mt-4">
            <div className="card shadow p-4">
                <div className="mb-4">
                    <h3 className="mb-1">Recalcular Día de Período</h3>
                    <p className="text-muted mb-0">
                        Ajuste manual oculto para agregar o actualizar un día puntual del período y recalcular sus turnos.
                    </p>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="row g-3">
                        <div className="col-md-3">
                            <label className="form-label">Período</label>
                            <MonthInput
                                className="form-control"
                                value={periodo}
                                onChange={(e) => setPeriodo(e.target.value)}
                                required
                            />
                        </div>
                        <div className="col-md-3">
                            <label className="form-label">Fecha</label>
                            <input
                                type="date"
                                className="form-control"
                                value={fecha}
                                min={fechaMin}
                                max={fechaMax}
                                onChange={(e) => setFecha(e.target.value)}
                                required
                            />
                        </div>
                        <div className="col-md-3">
                            <label className="form-label">Turno</label>
                            <select
                                className="form-select"
                                value={turno}
                                onChange={(e) => setTurno(e.target.value)}
                            >
                                <option value="1">Día</option>
                                <option value="2">Noche</option>
                                <option value="3">Ambos</option>
                            </select>
                        </div>
                        <div className="col-md-3">
                            <label className="form-label">Extra (%)</label>
                            <input
                                type="number"
                                className="form-control"
                                min="0"
                                max="1000"
                                value={extra}
                                onChange={(e) => setExtra(e.target.value)}
                                placeholder="0"
                            />
                        </div>
                        <div className="col-12">
                            <label className="form-label">Observación</label>
                            <textarea
                                className="form-control"
                                rows="3"
                                value={nota}
                                onChange={(e) => setNota(e.target.value)}
                                placeholder="Motivo o contexto del recálculo"
                            />
                        </div>
                    </div>

                    <div className="mt-4 d-flex gap-2">
                        <button type="submit" className="btn btn-primary">
                            Recalcular día
                        </button>
                        <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={() => {
                                setFecha('');
                                setTurno('3');
                                setExtra('');
                                setNota('');
                                setResultado(null);
                            }}
                        >
                            Limpiar
                        </button>
                    </div>
                </form>

                {resultado && (
                    <div className="alert alert-light border mt-4 mb-0">
                        <div><strong>Período:</strong> {resultado.periodo || periodo}</div>
                        <div><strong>Fecha:</strong> {resultado.fecha || fecha}</div>
                        <div><strong>Turno:</strong> {resultado.turno_label || '-'}</div>
                        <div><strong>Registros recalculados:</strong> {resultado.turnos_actualizados ?? 0}</div>
                        <div><strong>Nota aplicada:</strong> {resultado.nota_aplicada || '(sin observación)'}</div>
                        <div><strong>Extra aplicado:</strong> {resultado.extra_aplicado ?? 0}%</div>
                        {Array.isArray(resultado.debug) && resultado.debug.length > 0 && (
                            <div className="mt-3">
                                <strong>Log:</strong>
                                <pre
                                    className="bg-dark text-light p-3 rounded mt-2 mb-0"
                                    style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', maxHeight: 420, overflow: 'auto' }}
                                >
                                    {resultado.debug.join('\n')}
                                </pre>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default PeriodoTurnoRecalculoDia;
